<template>
	<div class="col">
		<div class="text-center mb-2 pt-1 border-bottom pb-1">
			<span style="font-size: 0.9rem; font-weight: bold; color: #ced4da; line-height: 22px;">{{ formattedDate }}</span>
		</div>
		<div v-if="stocks.length" class="plate-items-container">
			<div v-bind:key="data.index" v-for="(data) in stocks.slice(0,20)" class="mb-1">
				<PlateTextItem :plate_name="data.plate_name" :plate_code="data.plate_code" :pct=data.rate
				:c_num="show_score == 1 ? data.score : data.rate" :selected="data.plate_code === selectedPlateCode"
					@click="handlePlateClicked(data.plate_code)"></PlateTextItem>
			</div>
		</div>

		<div v-else>
			<span>loading...</span>
		</div>
		<div>
			<UplimitStepOnPlate v-if="showUplimitStep" :plate_code=selectedPlateCode :date1="date1" @show_sidebar="handleShowSidebar" @show-plate-kline="handleShowPlateKline"></UplimitStepOnPlate>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import {
		request_zzquant
	} from "network/request.js"

	import PlateTextItem from 'components/plate/PlateTextItem.vue'
	import UplimitStepOnPlate from 'components/uplimit/UplimitStepOnPlate.vue'

	export default {
		props: {
			date1: String,
			selectedPlateCode: String,
			plate_type: {
				type: Number,
				default: 15,
			},
			showUplimitStep: {
			type: Number,
			default: 0, // 默认不显示
			},
			show_score:{
				type: Number,
				default: 0,
			},
		},
		data() {
			return {
				stocks: []
			};
		},
		computed: {
			formattedDate() {
				if (!this.date1) return '';
				moment.locale('zh-cn'); // 设置中文
				return moment(this.date1).format('YY/MM/DD ddd');
			}
		},
		components: {
			PlateTextItem,
			UplimitStepOnPlate
		},
		mounted() {
			this.refresh_popular();
		},
		methods: {
			handlePlateClicked(plateCode) {
				// 从stocks数组中找到对应的plate_name
				const plateItem = this.stocks.find(item => item.plate_code === plateCode);
				const plateName = plateItem ? plateItem.plate_name : '';
				// 发送事件时同时传递plateCode和plateName
				// console.log(plateCode, plateName)
				this.$emit('plate-selected', plateCode, plateName)
			},
			handleShowSidebar(stock_info) {
				this.$emit('show_sidebar', stock_info)
			},
			handleShowPlateKline(plateInfo) {
				this.$emit('show-plate-kline', plateInfo)
			},
			mendZero(num) {
				return (num = num < 10 ? '0' + num : num)
			},
			refresh_popular() {
				// console.log(this.date1)
				request_zzquant({
						// url: 'stock/d/popular/' + this.date1
						// url: '/market/plates/25/rank/popular?date1=' + this.date1 + '&top_n=20'
						
						url: '/v3/market/plates/' + this.plate_type + '/rank?date1=' + this.date1 + '&limit=12'
					})
					.then(res1 => {
						this.stocks = res1['data']['data'];
						// 如果是第一个日期且有数据，发送第一个plate_code
						if (this.stocks.length > 0) {
							this.$emit('first-plate-loaded', this.stocks[0].plate_code, this.date1);
						}
                        this.$emit('data-loaded', this.date1, this.stocks);
					})
					.catch(err => {
						console.log(err);
					});
			},
			p_show_kline(symbol_code) {
				// console.log("p click "+symbol_code);
				this.$emit('p_show_kline', symbol_code)
			}
		},
		filters: {
			toFixedTwo(value) {
				if (!value) return '';
				value = Number(value);
				return value.toFixed(2);
			}
		},
	};
</script>

<style>

</style>